import { API,  Logger } from 'aws-amplify';
import { useDownload } from '@/func/useDownload';

const logger = new Logger('covidCertificate');

const covidCertificate = {
  namespaced: true,
  state: {
    covidCertificatePath: '',
    covidCertificateImageData: '',
  },
  getters: {
    covidCertificatePath: state => state.covidCertificatePath,
    covidCertificateImageData: state => state.covidCertificateImageData
  },
  mutations: {
    setCovidCertificatePath: (state, payload) => state.covidCertificatePath = payload,
    setCovidCertificateImageData: (state, payload) => state.covidCertificateImageData = payload,
  },
  actions: {
    /**
     * 陽性者証明書の登録
     * @param context
     * @param payload
     * @returns {Promise<void>}
     */
    register: async (context, payload) => {
      logger.info('register', payload);

      try {
        const response = await API.post('covidCertificate', '/post-image', {
          headers: { 'Content-Type': 'application/json' },
          body: {
            treatmentSerialNumber: payload.treatmentSerialNumber,
            diagnosedAt: payload.diagnosedAt,
          },
        });
        logger.info('register.response', response);

      } catch (e) {
        logger.error('register.exception', e);
        throw e;
      }
    },

    /**
     * 陽性者証明書画像のダウンロード
     * @param context
     * @param payload
     * @returns {Promise<void>}
     */
    downloadImage: async (context, payload) => {
      logger.info('downloadImage', payload);
      try {
        const response = await API.get('covidCertificate', '/get-image', {
          queryStringParameters: {
            accessToken: payload.accessToken,
            treatmentConsultationSeq: payload.treatmentConsultationSeq,
          },
        });
        logger.info('downloadImage.response', response);
        // pngファイルとしてダウンロードする
        useDownload().downloadPng(response, 'covid-certificate.png');
      } catch (e) {
        logger.error('downloadImage.exception', e.response);
        throw e;
      }
    },
    fetchImageData: async ({ commit }, payload) => {
      logger.info('fetchImageData', payload);
      try {
        const response = await API.get('covidCertificate', '/get-image', {
          queryStringParameters: {
            accessToken: payload.accessToken,
            treatmentConsultationSeq: payload.treatmentConsultationSeq,
          },
        });
        commit('setCovidCertificateImageData', response);
      } catch (e) {
        logger.error('fetchImageData.exception', e.response);
        throw e;
      }
    }
  },
};

export default covidCertificate;
